export const shouldRedirectToWeaveTraces = (
  tab: string | undefined,
  hasTraceData: boolean
): boolean => {
  // Root project url should redirect to weave traces tab if there is weave data
  return !tab && hasTraceData;
};
